import request from '../request';

export function getClientsAll(params) {
    return request({
        url: "/dispatcher/clients",
        method: "get",
        params,
    })
}

export function getOrderStatus(params) {
    return request({
        url: "client/client-order-statuses",
        method: "get",
        params
    })
}

export function getClientsByID(id, params) {
    return request({
        url: `/dispatcher/clients/${id}`,
        method: "get",
        params
    })
}

export function getClients(params) {
    return request({
        url: `/dispatcher/clients`,
        method: "get",
        params,
    })
}

export function searchClients(text) {
    return request({
        url: `/dispatcher/clients?search=${text.search}`,
        method: "get",
    })
}

export function postClients(data) {
    return request({
        url: "/dispatcher/clients",
        method: "post",
        data
    })
}

export function putClients(data) {
    return request({
        url: `/dispatcher/clients/${data.id}`,
        method: "put",
        data
    })
}

export function deleteClients(id) {
    return request({
        url: `/dispatcher/clients/${id}`,
        method: "delete"
    })
}

export function getLeadStatuses() {
    return request({
        url: "/client-lead-statuses",
        method: 'get',
    })
}

export function getClientStatuses() {
    return request({
        url: "/dispatcher/client-statuses",
        method: 'get',
    })
}

export function storeBulkClients(data) {
    return request({
        url: '/dispatcher/clients-bulk',
        method: 'post',
        data,
    })
}

export function getStatuses() {
    return request({
        url: "/dispatcher/client-lead-statuses",
        method: 'get',
    })
}


export function isStoreWaterCountClient(data) {
    return request({
        url: '/dispatcher/client-update-bottle-count',
        method: 'post',
        data
    })
}

export function isGetWaterCountRequest() {
    return request({
        url: '/dispatcher/get-client-bottle-update-requests',
        method: 'get'
    })
}

export function isOrdersFinish(data) {
    return request({
        url: '/dispatcher/orders-finish',
        method: 'put',
        data
    })
}

export function isChangeBottlesCountStatus(data) {
    return request({
        url: `/dispatcher/change-bottle-request-status/${data.id}`,
        method: 'put',
        data
    })
}

export function isActivitedClients(data) {
    return request({
        url: `/dispatcher/activate-clients`,
        method: 'put',
        data
    })
}

export function deleteBulkClients(id) {
    return request({
        url: `/dispatcher/clients-bulk/${id}`,
        method: 'delete',
    })
}

export function deleteDriverClients(driverId) {
    return request({
        url: `/dispatcher/delete-clients/${driverId}`,
        method: 'delete',
    })
}
